import { deepCloneObject } from 'functions';
import { advancePayConstants } from '../constants';
import { chargeMethodList } from 'constants/lists';

export function advancePayReducers(state = {}, action) {
    const { 
        totalRequests = 0,
        collectiveErrorMsg = ""
    } = state;

    let collectiveErrorMsg_formatted = collectiveErrorMsg;

    switch (action.type) {
            
        // Get Advance Pay Setup List
        
        case advancePayConstants.getAdvancePaySetupList_request:
            return {
                ...state,
                getAdvancePaySetupList_requesting: true, getAdvancePaySetupList_status: false,
            }
        case advancePayConstants.getAdvancePaySetupList_success:
            return {
                ...state,
                getAdvancePaySetupList_requesting: false, getAdvancePaySetupList_status: true,
                advancePaySetupList: action?.details?.data.map((obj) => {
                    let newObj = deepCloneObject(obj);
                    newObj.ChargeMethod = obj?.ChargeMethod && obj?.ChargeMethod >= 0? chargeMethodList[obj?.ChargeMethod]?.label:"";
                    return newObj;
                }),
                advancePaySetupListHeaders: action.details.headers
            }
        case advancePayConstants.getAdvancePaySetupList_failure:
            return {
                ...state,
                getAdvancePaySetupList_requesting: false, getAdvancePaySetupList_status: false, 
            }

        // Get All Advance Pay Setup List
            
        case advancePayConstants.getAllAdvancePaySetupList_request:
            return {
                ...state,
                getAllAdvancePaySetupList_requesting: true, getAllAdvancePaySetupList_status: false,
            }
        case advancePayConstants.getAllAdvancePaySetupList_success:
            return {
                ...state,
                getAllAdvancePaySetupList_requesting: false, getAllAdvancePaySetupList_status: true,
                allAdvancePaySetupList: action.details.data,
            }
        case advancePayConstants.getAllAdvancePaySetupList_failure:
            return {
                ...state,
                getAllAdvancePaySetupList_requesting: false, getAllAdvancePaySetupList_status: false, 
            }

        // Add Account

        case advancePayConstants.addAccount_request:
            return {
                ...state,
                addAccount_requesting: true, addAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                addAccount_errorMsg: undefined,
            }
        case advancePayConstants.addAccount_success:
            return {
                ...state,
                addAccount_requesting: false, addAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                isAccountRecordUpdateRequesting: false
            }
        case advancePayConstants.addAccount_failure:
            return {
                ...state,
                addAccount_requesting: false, addAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                addAccount_errorMsg: action?.error?.response?.data?.exceptionMessage
            }

        // Update Account

        case advancePayConstants.updateAccount_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                updateAccount_requesting: true, updateAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                isAccountRecordUpdateRequesting: true,
                updateAccount_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case advancePayConstants.updateAccount_success:
            return {
                ...state,
                updateAccount_requesting: (totalRequests > 1), updateAccount_status: true,
                isAccountRecordUpdatedSuccessfully: (totalRequests - 1) == 0,
                isAccountRecordUpdateRequesting: false,
                totalRequests: (totalRequests - 1)
            }
        case advancePayConstants.updateAccount_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;
    
            return {
                ...state,
                updateAccount_requesting: (totalRequests > 1), updateAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                isAccountRecordUpdateRequesting: false,
                updateAccount_errorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Generate Invoice
        
        case advancePayConstants.generateInvoice_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                generateInvoice_requesting: true, generateInvoice_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                generateInvoice_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case advancePayConstants.generateInvoice_success:
            return {
                ...state,
                generateInvoice_requesting: (totalRequests > 1), generateInvoice_status: true,
                isAccountRecordUpdatedSuccessfully: (totalRequests - 1) == 0,
                totalRequests: (totalRequests - 1)
            }
        case advancePayConstants.generateInvoice_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                generateInvoice_requesting: (totalRequests > 1), generateInvoice_status: false,
                isAccountRecordUpdatedSuccessfully: false,
                generateInvoice_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Generate Debit Note
        
        case advancePayConstants.generateDebitNote_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                generateDebitNote_requesting: true, generateDebitNote_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                generateDebitNote_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case advancePayConstants.generateDebitNote_success:
            return {
                ...state,
                generateDebitNote_requesting: (totalRequests > 1), generateDebitNote_status: true,
                isAccountRecordUpdatedSuccessfully: ((totalRequests - 1) == 0),
                totalRequests: (totalRequests - 1)
            }
        case advancePayConstants.generateDebitNote_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                generateDebitNote_requesting: (totalRequests > 1), generateDebitNote_status: false,
                isAccountRecordUpdatedSuccessfully: false,
                generateDebitNote_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Delete Account
        
        case advancePayConstants.deleteAccount_request:
            if (totalRequests == 0) 
            collectiveErrorMsg_formatted = "";
            
            return {
                ...state,
                deleteAccount_requesting: true, deleteAccount_status: false,
                isAccountRecordUpdatedSuccessfully: undefined,
                deleteAccount_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case advancePayConstants.deleteAccount_success:
            return {
                ...state,
                deleteAccount_requesting: (totalRequests > 1), deleteAccount_status: true,
                isAccountRecordUpdatedSuccessfully: true,
                totalRequests: totalRequests - 1
            }
        case advancePayConstants.deleteAccount_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                deleteAccount_requesting: (totalRequests > 1), deleteAccount_status: false, 
                isAccountRecordUpdatedSuccessfully: false,
                deleteAccount_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: totalRequests - 1
            }

        default:
            return state;
    }
}